import { Component, OnInit } from '@angular/core';
import * as $ from 'jquery';

@Component({
  selector: 'app-caroussel',
  templateUrl: './caroussel.component.html',
  styleUrls: ['./caroussel.component.scss']
})
export class CarousselComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

  prev() {
    ($('#myCarousel') as any).carousel('prev');
  }

  next() {
    ($('#myCarousel') as any).carousel('next');
  }
}
